import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HeatMapModuleName } from '@/store/modules/modules'

export class HeatMapViewModel {
  private store = useStore()

  userJudgeRecordList: ComputedRef<JudgeRecord[]> = computed(
    () => this.store.getters[`${HeatMapModuleName}/userJudgeRecordList`]
  )
  heatMapXLabel: ComputedRef<string[]> = computed(() => this.store.getters[`${HeatMapModuleName}/heatMapXLabel`])
  heatMapSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${HeatMapModuleName}/heatMapSeries`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${HeatMapModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${HeatMapModuleName}/error`])

  async getUserJudgeRecord(userId: string): Promise<void> {
    await this.store.dispatch(`${HeatMapModuleName}/getUserJudgeRecord`, { userId: userId })
  }

  setHeatMapSeries(series: any[]): void {
    this.store.commit(`${HeatMapModuleName}/setHeatMapSeries`, { series: series })
  }

  setHeatMapXLabel(labels: string[]): void {
    this.store.commit(`${HeatMapModuleName}/setHeatMapXLabel`, { labels: labels })
  }
}
